import styled from "styled-components";

let titleBarHeight = 60;

export const ElectricWheelConciseDetailsWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    color: #FFFFFF;
    letter-spacing: 2px;
    color: #EFEFEF;
    background-color: rgb(5, 12, 38);
`;

export const ElectricWheelDetailsConciseInnerWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 850px;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-image: url("/static/images/big-screen/electric-wheel-concise/overview-background.png");
    background-size: 100% 100%;
`;

export const ScreenTitleBar = styled.div`
    z-index: 100;
    width: 100%;
    height: ${titleBarHeight}px;
    padding: 0px 10px 0px 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
`;

export const StatusBar = styled.div`
    display: flex;
    flex-direction: row;
    padding: 0px 20px;
    gap: 20px;
`;

export const DeviceName = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: rgba(16, 41, 71, 1.0);
    padding: 0px 30px 0px 50px;
    height: 40px;
    font-size: 20px;
    clip-path: polygon(0 0, calc(100% - 25px) 0, 100% 50%, calc(100% - 25px) 100%, 0 100%, 25px 50%, 0 0);
`;

export const DeviceStatus = styled.div`
    display: flex;
    align-items: center;
    font-size: 20px;
    height: 32px;
    padding: 4px 24px 2px 24px;
    border-radius: 28px;
    background-color: rgba(255, 255, 255, 0.1);
`;

export const DetailsBigScreenContent = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 800px;
    padding: 10px 30px 32px 30px;
    overflow-x: hidden;
    overflow-y: hidden;
    box-sizing: border-box;
    z-index: 100;
`;

export const LeftColumnMetrics = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
    width: 300px;
`;

export const RightColumnMetrics = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 20px;
    width: 300px;
`;


export const MetricsGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 5px;
    height: 200px;
    padding: 5px;
    border: 3px solid rgba(255, 255, 255, 0.1); 
`;

export const MetricsGroupHeader = styled.div`
    font-size: 16px;
    padding: 10px 10px;
    background-color: rgba(255, 255, 255, 0.1);
`;

export const MetricsGroupContent = styled.div`
    flex: 1 1 0px;
    background-color: rgba(255, 255, 255, 0.05);
`;

export const MetricsItem = styled.div`
    background-color: rgba(255, 255, 255, 0.05);
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const MetricsItemLabel = styled.div`
    white-space: nowrap;
    text-align: right;
    width: 100px;
`;

export const MetricsItemValue = styled.div`
    flex: 1 1 0px;
`;

export const MetricsItemUnit = styled.div`
    width: 80px;
`; 

export const ElectricWheelDiagram = styled.img`
    width: 800px;
    height: auto;
    margin: 0px 50px;
`;

export const BottomBar = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 50px;
`;

export const BottomItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 20px;
    height: 28px;
    box-sizing: border-box;
    border-radius: 14px;
    background-color: rgba(255, 255, 255, 0.1); 

    &:first-child {
        background-color: rgba(119, 40, 245, 0.5);
    }

    &:nth-child(2) {
        background-color: rgba(194, 53, 49, 0.5);
    }

    &:nth-child(3) {
        background-color: rgba(100, 130, 230, 0.5);
    }
`;

export const BottomItemName = styled.div`
    min-width: 80px;
    text-align: right;
`;

export const BottomItemValue = styled.div`
    
`;




